import advSearchRoutes from "./routes/advSearchRoutes";
import attributeManagerRoutes from "./routes/attribute-manager";
import automationServerRoutes from "./routes/automation-server";
import channelCreatorRoutes from "./routes/channel-creator";
import configurationManagerRoutes from "./routes/configuration-manager";
import contentEditorRoutes from "./routes/content-editor";
import gpsrRoutes from "./routes/gpsr";
import dashboardRoutes from "./routes/dashboard";
import debugRoutes from "./routes/debug-routes";
import exportRoutes from "./routes/export";
import importRoutes from "./routes/import";
import moduleRoutes from "./routes/module-routes";
import settingsRoutes from "./settings-routes";
import translationManagerRoutes from "./routes/translation-manager";
import userManagerRoutes from "./routes/user-manager";
import workManagerRoutes from "./routes/work-manager";

import store from "@/store";
import client from "@common/views/Client.vue";
import login from "@common/views/Login.vue";
import logout from "@common/views/Logout.vue";
import splash from "@common/views/Splash.vue";
import status from "@common/views/Status/ExtendedStatus.vue";

const routes = [
  {
    path: "/",
    name: "app-base",
    component: () =>
      new Promise((resolve) => {
        resolve(store.getters.isAuthenticatedSession ? client : splash);
      }),

    meta: {
      authenticatedRoute: true
    },
    children: [
      ...contentEditorRoutes,
      ...advSearchRoutes,
      ...channelCreatorRoutes,
      ...attributeManagerRoutes,
      ...configurationManagerRoutes,
      ...dashboardRoutes,
      ...gpsrRoutes,
      ...moduleRoutes,
      ...automationServerRoutes,
      ...exportRoutes,
      ...importRoutes,
      ...userManagerRoutes,
      ...settingsRoutes,
      ...translationManagerRoutes,
      ...workManagerRoutes,
      /* add new routes before debug routes */
      ...debugRoutes
    ]
  },
  {
    path: "/app/login",
    name: "login",
    component: login,
    meta: {
      fullReload: true
    },
    children: [
      {
        path: "oauth/:provider",
        name: "login-provider",
        component: login
      }
    ]
  },
  {
    path: "/app/logout",
    name: "logout",
    component: logout,
    meta: {
      fullReload: true
    }
  },
  {
    path: "/app/status",
    name: "status",
    component: status,
    meta: {
      authenticatedRoute: true
    }
  }
];

export default routes;
